import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Card, Typography, Stack } from '@mui/material';
// utils
import { fNumber, fPercent } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.dark,
  backgroundColor: alpha(theme.palette.primary.main, 0.24),
}));

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  percent: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error']),
};

export default function AppWidgetSummary({ title, percent, total, color = 'primary' }) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 3,
        boxShadow: 'none',
        backgroundColor: alpha(theme.palette[color].main, 0.12),
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>

        <Typography variant="h3" sx={{ mt: 1 }}>
          {fNumber(total)}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1.5 }}>
          <IconWrapperStyle
            sx={{
              ...(percent < 0 && {
                color: 'error.dark',
                bgcolor: alpha(theme.palette.error.main, 0.16),
              }),
            }}
          >
            <Iconify width={16} height={16} icon={percent >= 0 ? 'eva:trending-up-fill' : 'eva:trending-down-fill'} />
          </IconWrapperStyle>
          <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {percent > 0 && '+'}
            {fPercent(percent)}
          </Typography>
        </Stack>
      </Box>
    </Card>
  );
}
